import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LastIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Last",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.42 29.52c.31.3.74.48 1.21.48.5 0 .94-.21 1.26-.54L29.51 17.3v-.08l.11-.17c.07-.09.13-.18.18-.29.03-.1.05-.21.07-.32.03-.1.05-.22.06-.33 0-.13-.03-.24-.06-.35-.01-.11-.04-.22-.07-.32-.06-.1-.12-.2-.19-.29s-.11-.17-.11-.17v-.08L17.89 2.73c-.32-.4-.81-.66-1.37-.66-.97 0-1.75.78-1.75 1.75 0 .52.23.99.59 1.31s10.47 10.99 10.47 10.99L15.36 27.11c-.29.31-.46.72-.46 1.18 0 .48.2.92.52 1.23m-12.7 0c.31.3.74.48 1.21.48.5 0 .94-.21 1.26-.54L16.81 17.3v-.08l.11-.17c.07-.09.13-.18.18-.29.04-.12.06-.24.08-.37.03-.1.05-.22.06-.33 0-.13-.03-.24-.06-.35-.01-.11-.04-.22-.07-.32-.06-.1-.12-.2-.19-.29s-.11-.17-.11-.17v-.08L5.18 2.66C4.86 2.26 4.37 2 3.81 2c-.97 0-1.75.78-1.75 1.75 0 .52.23.99.59 1.31s10.47 10.99 10.47 10.99l-10.46 11a1.743 1.743 0 0 0 .05 2.47Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.43 27.71c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l9.48-9.48-9.48-9.47a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l10.29 10.29c.45.45.45 1.17 0 1.62L17.24 27.39c-.22.22-.52.33-.81.33Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5 27.71c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l9.48-9.48-9.48-9.47a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0L16.1 15.48c.45.45.45 1.17 0 1.62L5.81 27.39c-.22.22-.52.33-.81.33Z"
      })]
    })
  }));
};